import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import CoffeeHeader from '../components/coffee/CoffeeHeader';
import CoffeeFilters from '../components/coffee/CoffeeFilters';
import CoffeeList from '../components/coffee/CoffeeList';
import CreateCoffeeModal from '../components/coffee/CreateCoffeeModal';
import { XIcon } from 'lucide-react';
const EIISCoffeePage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState<'all' | 'upcoming' | 'mine' | 'past'>('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTopic, setSelectedTopic] = useState('all');
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  return <div className="flex h-screen bg-gray-100" data-id="element-2467">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-2468">
        {/* Sidebar backdrop */}
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-2469"></div>
        {/* Sidebar */}
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-2470">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-2471">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-2472">
              <span className="sr-only" data-id="element-2473">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-2474" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-2475">
            <Sidebar activePage="community" data-id="element-2476" />
          </div>
        </div>
      </div>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2477">
        <Sidebar activePage="community" data-id="element-2478" />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2479">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-2480" />

        <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-100" data-id="element-2481">
          <div className="pt-4 md:pt-6 max-w-6xl mx-auto" data-id="element-2482">
            <CoffeeHeader onCreateClick={() => setIsCreateModalOpen(true)} data-id="element-2483" />

            <div className="mt-6" data-id="element-2484">
              <CoffeeFilters activeFilter={activeFilter} setActiveFilter={setActiveFilter} searchQuery={searchQuery} setSearchQuery={setSearchQuery} selectedTopic={selectedTopic} setSelectedTopic={setSelectedTopic} data-id="element-2485" />
            </div>

            <div className="mt-6" data-id="element-2486">
              <CoffeeList activeFilter={activeFilter} searchQuery={searchQuery} selectedTopic={selectedTopic} data-id="element-2487" />
            </div>
          </div>
        </main>
      </div>

      {/* Create Event Modal */}
      <CreateCoffeeModal isOpen={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)} data-id="element-2488" />
    </div>;
};
export default EIISCoffeePage;